import React from "react";
import MyIcon from "./MyIcon";
import HelpButton from "../HelpContent/HelpButton";

export default function PageHeader({
  Icon,
  heading,
  subheading,
  children,
  className = "",
}: {
  Icon?: any;
  heading: any;
  subheading: string;
  children?: any;
  className?: string;
}) {
  return (
    <div
      className={
        "d-flex flex-wrap justify-content-between align-items-center my-2" +
        className
      }
    >
      <div className="d-flex align-items-start">
        {Icon && <MyIcon Icon={Icon} className="m-2 text-purple" />}
        <div className="ms-2">
          <h1 className="fw-bold mb-0">
            {heading}{" "}
            <span onClick={(e) => e.stopPropagation()}>
              <HelpButton
                helpKey={heading.toString().toLowerCase().replace(/\s+/g, "-")+'-page'}
              />
            </span>
          </h1>
          <span className="opacity-50">{subheading}</span>
        </div>
      </div>
      {children}
    </div>
  );
}
